var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, Model, File } from '@1amageek/ballcap';
export class Members extends Model {
    static fromNewMembers(clinic, worker) {
        const data = new Members();
        data.clinicId = clinic.id;
        data.clinicName = clinic.clinicName;
        data.clinicImage = clinic.image;
        data.workerId = worker.id;
        data.workerFirstName = worker.firstName;
        data.workerLastName = worker.lastName;
        data.workerImage = worker.image;
        return data;
    }
}
__decorate([
    Field,
    __metadata("design:type", String)
], Members.prototype, "clinicId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Members.prototype, "clinicName", void 0);
__decorate([
    Field,
    __metadata("design:type", File
    // Worker
    )
], Members.prototype, "clinicImage", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Members.prototype, "workerId", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Members.prototype, "workerFirstName", void 0);
__decorate([
    Field,
    __metadata("design:type", String)
], Members.prototype, "workerLastName", void 0);
__decorate([
    Field,
    __metadata("design:type", File)
], Members.prototype, "workerImage", void 0);
